import { CONTACT_EMAIL, H2, LegalLayout, P, Table, Ul } from './shared';

// Public, unauthenticated route (see App.tsx) - same content as
// landing/templates.mjs's renderSubprocessors(), ported to this app's
// components.
export function SubprocessorsScreen() {
  return (
    <LegalLayout title="Sub-processors">
      <P>
        zmist uses a small number of third-party providers ("sub-processors") to run the Service. Each one only
        processes what it needs to do its job, and none is permitted to use your data for its own purposes. This
        page is the current list; we update it here before bringing a new sub-processor online.
      </P>

      <H2>Active</H2>
      <Table>
        <thead>
          <tr className="text-left border-b border-black/10 dark:border-white/10">
            <th className="py-1.5 pr-3 font-semibold">Provider</th>
            <th className="py-1.5 pr-3 font-semibold">Purpose</th>
            <th className="py-1.5 pr-3 font-semibold">Data processed</th>
            <th className="py-1.5 font-semibold">Location</th>
          </tr>
        </thead>
        <tbody className="text-black/70 dark:text-white/70">
          <tr className="border-b border-black/5 dark:border-white/5">
            <td className="py-1.5 pr-3">Hetzner Online GmbH</td>
            <td className="py-1.5 pr-3">Application servers and database hosting</td>
            <td className="py-1.5 pr-3">All account, channel, schema, and signal data</td>
            <td className="py-1.5">European Union</td>
          </tr>
          <tr className="border-b border-black/5 dark:border-white/5">
            <td className="py-1.5 pr-3">Cloudflare, Inc.</td>
            <td className="py-1.5 pr-3">DNS and network protection in front of web traffic</td>
            <td className="py-1.5 pr-3">Connection metadata (IP address, request timing)</td>
            <td className="py-1.5">Global edge network</td>
          </tr>
          <tr className="border-b border-black/5 dark:border-white/5">
            <td className="py-1.5 pr-3">S3-compatible object storage</td>
            <td className="py-1.5 pr-3">Storage of avatar and channel images you upload</td>
            <td className="py-1.5 pr-3">Uploaded image files and their keys</td>
            <td className="py-1.5">European Union</td>
          </tr>
          <tr>
            <td className="py-1.5 pr-3">SMTP email provider</td>
            <td className="py-1.5 pr-3">Transactional email only (password reset, 2FA codes, channel invites, account-deletion confirmation)</td>
            <td className="py-1.5 pr-3">Recipient email address and message contents</td>
            <td className="py-1.5">May process outside the EU under Standard Contractual Clauses</td>
          </tr>
        </tbody>
      </Table>
      <P>
        Where a specific provider isn't named above, it's because the choice is still being finalised - email{' '}
        {CONTACT_EMAIL} if you need the current detail for a vendor assessment.
      </P>

      <H2>Planned (not yet active)</H2>
      <P>These are on the roadmap and will move to the "Active" table, with full detail, before they process any user data:</P>
      <Ul>
        <li>A privacy-friendly, cookieless analytics provider for aggregate usage on the marketing site.</li>
        <li>An LLM provider for the optional AI-generated report feature (only the channel data you choose to summarise would be sent).</li>
        <li>Web-push and Apple Push Notification services for notifications you opt into.</li>
        <li>A payment provider, if and when paid plans launch.</li>
      </Ul>

      <H2>Changes</H2>
      <P>We'll update the date at the top of this page whenever this list changes. Questions: {CONTACT_EMAIL}.</P>
    </LegalLayout>
  );
}
